import React from 'react';
import './terms-overview.scss';
import { TermsBlockBasePrice } from './TermsBlockBasePrice';
import { TermsBlockDiscount } from './TermsBlockDiscount';
import { TermsBlockItems } from './TermsBlockItems';
import { TermsBlockService } from './TermsBlockService';
import { TermsBlockStop } from './TermsBlockStop';
import { TermsBlockTotalPrice } from './TermsBlockTotalPrice';
import { TermsBlockType } from './TermsBlockType';
import { TermsBlockCustomer } from './TermsBlockCustomer';
import { TermsBlockInsurance } from './TermsBlockInsurance';

export const TermsOverview = (): JSX.Element => {
  return (
    <>
      <TermsBlockBasePrice />
      <TermsBlockType />
      <TermsBlockService />
      <TermsBlockItems />
      <TermsBlockStop stop={'pickup'} />
      <TermsBlockStop stop={'delivery'} />
      <TermsBlockInsurance />
      <TermsBlockDiscount />
      <TermsBlockTotalPrice />
      <TermsBlockCustomer />
    </>
  );
};
